import React, { useEffect } from "react";
import AppRoute from "@/route";
import { useLocation } from "react-router-dom";
import { GlobalStoreContext } from "./store/hooks";
import { useLocalStore } from "mobx-react";
import GlobalStore from "./store/GlobalStore";
import AuthTokenHolder from "./services/http/AuthTokenHolder";

interface AppProps {}

const App: React.FC<AppProps> = function (props) {
  const location = useLocation();

  const globalStore = useLocalStore(() => new GlobalStore());

  useEffect(() => {
    const search = location.search;

    const searchParams = new URLSearchParams(search);

    const token = searchParams.get("_token_") || AuthTokenHolder.getToken();

    if (token) {
      globalStore.init(token);
    }
  }, []);

  return (
    <GlobalStoreContext.Provider value={globalStore}>
      <AppRoute />
    </GlobalStoreContext.Provider>
  );
};

export default React.memo(App);
